
import { computed, defineComponent, onBeforeUnmount, Ref, ref } from "vue";
import { ElConfigProvider } from "element-plus";
import useEmitter from "@/composables/Emmiter";
import Button from "@/components/Button.vue"
import useAlert from "@/composables/Alert";
import axios from "axios";


export default defineComponent({
  name: "ModalAdicionarFiltro",
  components: {
    Button, 
    ElConfigProvider
  },
  props: {
    fechaModal: Function,
    marcas: { type: Array as () => Array<{ nome: string; id_marca_produto: string | number }>, default: () => [] },
    tiposDeFiltro: { type: Array as () => Array<{ id_tipo_produto: string, nome: string; descricao: string | number }>, default: () => [] }
  },
  setup(props, { emit }) {
    //ALERTS TOASTS
    const spanWarning = ref(false);
    const { showTimeAlert } = useAlert();

    //VARIAVEIS DE CONTROLE
    const loadSalvar: Ref<boolean> = ref(false);
    const emitter = useEmitter();
    const imagem = ref<HTMLInputElement>();
    const marcasDeFiltros = computed(() => props.marcas);
    const filtroAddForm: any = ref({
        id_marca: "",
        filtro: "",
        id_tipo: "",
        descricao: "",
        ean: "",
        status: "",
        imagem: ""
    });
    const statusOptions = ['Disponível', 'Obsoleto'];

    async function getToken() {
      return localStorage.getItem("token_usuario");
    }

    const validateOnlyNumbers = (val: string, field: string) => {
      filtroAddForm.value[field] = val.replace(/\D/g, '');
    };

    function verifySelectValues(e) {
      e.preventDefault();
      if (!filtroAddForm.value.id_tipo || !filtroAddForm.value.id_marca || !filtroAddForm.value.filtro || !filtroAddForm.value.ean || !filtroAddForm.value.status) {
        spanWarning.value = true;
        return true;
      }
      spanWarning.value = false;
      addFiltro();
    }

    async function addFiltro() {
      if (emitter && emitter.emit) emitter.emit("addFiltro:start");

      try {
        let body: any = filtroAddForm.value;
        const headers: any = { Authorization: `Bearer ${await getToken()}` };

        if (filtroAddForm.value?.imagem instanceof File) {
          const formData = new FormData();
          Object.entries(filtroAddForm.value).forEach(([key, val]) => {
            if (key === "imagem") return;
            if (val === undefined || val === null){
              formData.append(key, "");
            } 
            else if (typeof val === "object"){
              formData.append(key, JSON.stringify(val));
            } else {
              formData.append(key, String(val));
            }
          });
          formData.append("imagem", filtroAddForm.value.imagem);
          body = formData;
        }

        await axios.post("adicionaFiltro", body, { headers });

        // resetar campos
        filtroAddForm.value = {
          id_marca: "",
          nome: "",
          id_tipo: "",
          descricao: "",
          ean: "",
          status: "",
          imagem: ""
        };

        if (emitter && emitter.emit) emitter.emit("addFiltro:finish", { success: true });
      } catch (err: any) {
        console.error(err);
        if (err.response && err.response.data && err.response.data.error) {
          showTimeAlert(err.response.data.message || "Erro desconhecido", "error");
        } else {
          showTimeAlert("Não foi possivel adicionar o produto.", "error");
        }
        if (emitter && emitter.emit) emitter.emit("addFiltro:finish", { success: false });
      }
    }

    // helper para gerar preview
    let currentObjectUrl: string | null = null;
    function buildImagePreview(img: any) {
      if (!img) return null;
      if (img instanceof File) {
        if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
        currentObjectUrl = URL.createObjectURL(img);
        return currentObjectUrl;
      }
      // string (URL)
      return typeof img === "string" ? img : null;
    }

    const fileName = computed(() => {
        const v = filtroAddForm.value.imagem;
        return v instanceof File ? v.name : "";
    });

    function handleImgFileChange(event: Event) {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      if (file) {
        filtroAddForm.value.imagem = file;
        filtroAddForm.value.imagemPreview = buildImagePreview(file);
      }
    }

    // handlers para atualizar o spinner e fechar o modal quando finalizado
    const startHandler = () => {
      loadSalvar.value = true;
    };

    const finishHandler = (payload?: any) => {
      loadSalvar.value = false;
      // fecha o modal somente depois de terminar
      // opcional: você pode checar payload.success para mostrar mensagem
      if(payload?.success){
        props.fechaModal && props.fechaModal();
      }
    };

    if (emitter && emitter.on) {
      emitter.on("addFiltro:start", startHandler);
      emitter.on("addFiltro:finish", finishHandler);
    }

    // remove listeners quando componente desmontar
    onBeforeUnmount(() => {
      if (emitter && emitter.off) {
        emitter.off("addFiltro:start", startHandler);
        emitter.off("addFiltro:finish", finishHandler);
      }
    });

    function openFileDialog() {
      imagem.value?.click();
    }

    return {
      spanWarning,
      filtroAddForm,
      verifySelectValues,
      marcasDeFiltros,
      loadSalvar,
      handleImgFileChange,
      fileName,
      statusOptions,
      openFileDialog,
      imagem,
      validateOnlyNumbers
    };
  }
});
